var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"video__filter",on:{"click":_vm.handleClickFilter}},[_vm._v(" FILTRAR "),_c('Arrow',{staticClass:"video__filter-arrow",attrs:{"fill":"var(--neutralcolor-low-pure)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }